'use strict';

import { ajaxWrapNew, CommandRegistry, ResponseDispatcher } from './ajaxWrapNew.js';
import { autoSyncer } from './autoSyncer.js';
import { getAnimScript, getJsonData } from './dataHelpers.js';


function initEnergyFieldPage(conf) {
    var scene1Anim, scene2Anim;
    var currentScene = conf.currentScene;
    var isConnected = conf.isConnected;

    const $switchButton = $('.switchButton');
    const switchTitles = $switchButton.data('titles');
    var offTimer = null;

    const switchAnimationTo = (newScene) => {
        return new Promise((resolve, reject) => {
            if (newScene === currentScene) {
                resolve();
                return;
            }
            currentScene = newScene;

            const offIdx = currentScene === 1 ? 2 : 1;
            const onIdx = currentScene === 1 ? 1 : 2;
            const offAnim = currentScene === 1 ? scene2Anim : scene1Anim;
            const onAnim = currentScene === 1 ? scene1Anim : scene2Anim;

            $switchButton.attr('data-currentscene', newScene).data('currentscene', newScene);

            $('.scene'+offIdx)
                .stop(true, false)
                .delay(conf.off.delay)
                .animate({
                    opacity: 0
                }, conf.off.speed, function () {
                    offAnim.togglePause(true);

                    if (onAnim.playStarted) {
                        onAnim.togglePause(false);
                    } else {
                        onAnim.playStart();
                    }
                    $('.scene'+onIdx)
                        .stop(true, false)
                        .delay(conf.on.delay)
                        .animate({
                            opacity: 1
                        }, conf.on.speed, function () {
                            $switchButton.data('switching', false);
                            resolve();
                        });

                    // Pārslēdzoties teksts uzdziest 1 sec, 3 sec rādās un pēc tam 2 sec nodziest.
                    $('.scene'+onIdx).find('.sceneTitle')
                        .stop(true, false)
                        .delay(conf.ton.delay)
                        .animate({
                            opacity: 1
                        }, conf.ton.speed, function () {
                            clearTimeout(offTimer);
                            offTimer = setTimeout(function() {
                                $(this).animate({
                                    opacity: 0
                                }, conf.toff.speed);
                            }.bind(this), conf.toff.delay); // 3 sec delay before fading out
                        });

                    $switchButton.attr('title', switchTitles[currentScene] || '');
                });
        });
    };

    const energyFieldCommands = {
        'switchEnergyField': async (payload) => {
            await switchAnimationTo(payload.newScene);
        },
    };
    CommandRegistry.registerCommands(energyFieldCommands);

    if (typeof modAnimationRun === 'undefined') {
        return;
    }
    scene1Anim = new modAnimationRun({
        autoplay: currentScene == 1 ? true : false,
        prepare: true,
        groups: conf.scene1Script.groups,
        animations: conf.scene1Script.animations,

        animationContainer: '.scene1Animation'
    }, $('.scene1').get(0));

    scene2Anim = new modAnimationRun({
        autoplay: currentScene == 2 ? true : false,
        prepare: true,
        groups: conf.scene2Script.groups,
        animations: conf.scene2Script.animations,

        animationContainer: '.scene2Animation'
    }, $('.scene2').get(0));

    if (isConnected) {
        /* connectAnim.togglePause(true); */
    }


    $('.withSwitch').on('click', function(event) {
        event.stopPropagation();
        $switchButton.trigger('click');
    });
    $switchButton.on('click', function(event) {
        //const newScene = $(this).data('currentscene') === 1 ? 2 : 1;
        //$(this).attr('data-currentscene', newScene).data('currentscene', newScene);
        if ($switchButton.data('switching')) {
            return;
        }
        $switchButton.data('switching', true);

        /* const newScene = $(this).data('currentscene') === 1 ? 2 : 1;
        switchAnimationTo(newScene);
        return; */
        ajaxWrapNew({
            method: 'POST',
            data: {
                ajax: 1,
                action: 'switch-energy-field'
            },
            success: async function (data) {
                await ResponseDispatcher.handle(data, 'switch-energy-field');
                $switchButton.data('switching', false);
            },
            error: function () {
                $switchButton.data('switching', false);
            },
            dataType: 'json'
        });
    });


    $('.connstf').on('click', function(event) {
        event.stopPropagation();
        $('.connstf-add').toggle();
    });
    /* $('.connstf').on('click', function(event) {
        event.stopPropagation();
        $('.connstf-add').toggle(true);
    });
    $('.connstf-add').on('click', function(event) {
        event.stopPropagation();
    });
    $(document).on('click', function() {
        $('.connstf-add').hide();
    }); */
}

function addEnergyPageCounter(connectSID, connectIID, iid) {
    const id = 'cnti' + iid;
    const $counterContainer = $('.' + id);

    autoSyncer.setGlobal('connectSID', connectSID);
    autoSyncer.setGlobal('connectIID', connectIID);

    CommandRegistry.registerCommand('energyPageCounter', (counterData) => {
        if (counterData.counterTT) {
            $counterContainer.find('.connstf')
                .html(counterData.counter)
                .attr('title', counterData.counterTT);
        }
        if (counterData.counterTX) {
            $counterContainer.find('.connstf-add')
                .html(counterData.counterTX);
        }
        if (counterData.counter !== undefined) {
            if ($counterContainer.data('cnt') != counterData.counter) {
                $counterContainer.data('cnt', counterData.counter);
            }
        }
    });

    autoSyncer.add('energy-page-counter', id, {
        counter: $counterContainer.data('cnt'),
        iid: iid
    }, function (itemData) {
        if (itemData.counter !== undefined) {
            return {
                counter: itemData.counter
            };
        }
        return false;
    });
}

export function loadEnergyField() {
    const loadData = getJsonData('app-energy-field');

    loadData.scene1Script = getAnimScript(loadData.scene1Script);
    loadData.scene2Script = getAnimScript(loadData.scene2Script);

    initEnergyFieldPage({
        isConnected: loadData.isConnected,
        currentScene: loadData.currentScene,
        canSwitchScene: loadData.canSwitchScene,
        scene1Script: loadData.scene1Script,
        scene2Script: loadData.scene2Script,
        off: loadData.conf.off,
        on: loadData.conf.on,
        toff: loadData.conf.toff,
        ton: loadData.conf.ton
    });

    addEnergyPageCounter(loadData.connectSID, loadData.connectIID, loadData.iid);

}